import { Alert, Box, Snackbar } from '@mui/material';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { getAlertConfig, getIsAlertVisible } from '@redux/alert/alertSelectors';
import { ReduxState } from '@redux/types';
import { CloseIconButton } from 'components/Button/CloseButton/CloseIconButton';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './AlertInfoGlobal.scss';
import { useAlert } from './useAlert';

type Props = ConnectedProps<typeof connectRedux>;

const AlertInfoGlobal: React.FC<Props> = ({ config: { iconSrc, vertical = 'top', horizontal = 'right', title, message, duration = 5000 }, isAlertVisible }) => {
  const icon = <img src={iconSrc} className={style.icon} alt="icon" />;
  const { hideAlert } = useAlert();

  return (
    <Box>
      <Snackbar anchorOrigin={{ vertical, horizontal }} open={isAlertVisible} autoHideDuration={duration} key={vertical + horizontal}>
        <Alert
          onClose={hideAlert}
          className={style.alert}
          icon={icon}
          action={<CloseIconButton onClick={hideAlert} containerClassName={style.closeIconButton} />}
          /*   <IconButton aria-label="close" color="inherit" size="large" onClick={hideAlert}>
              <CloseIcon fontSize="inherit" />
            </IconButton>*/
        >
          <div className={style.textWrapper}>
            <Text variant="sm" weight={700}>
              {title}
            </Text>
            <Text variant="sm" color={Color.GRAY}>
              {message}
            </Text>
          </div>
        </Alert>
      </Snackbar>
    </Box>
  );
};

const connectRedux = connect(
  (state: ReduxState) => ({
    config: getAlertConfig(state),
    isAlertVisible: getIsAlertVisible(state)
  }),
  {}
);

export default compose(connectRedux)(AlertInfoGlobal);
